/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ManageRecommendationAction {
    getFixupPrototypeFunction() { return ManageRecommendationAction.fixupPrototype; }

    static newInstance(model: Partial<ManageRecommendationAction>): ManageRecommendationAction {
        let obj = Object.assign(new ManageRecommendationAction(), model);
        ManageRecommendationAction.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ManageRecommendationAction>): ManageRecommendationAction {
        if (!model) return null;
        return ManageRecommendationAction.newInstance(<ManageRecommendationAction> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ManageRecommendationAction) {
        if (!obj) return;

        models.ManageRecommendationAction.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ManageRecommendationAction): boolean {
        Object.setPrototypeOf(obj, ManageRecommendationAction.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.rejection_duration_days === undefined) {
            this.rejection_duration_days = 0;
        }
    }

    /**
     * Type of the Actions to be passed in the request.
     */
    action_type: models.RequestsActionsType;

    /**
     * Unique Id for the resource.
     */
    resource_id: string;

    /**
     * Unique Id for the Recommendation.
     */
    recommendation_sys_id: string;

    /**
     * Unique Id for the workflow.
     */
    workflow_id: string;

    /**
     * Duration of the rejected period.
     */
    rejection_duration_days: number;

    /**
     * Reason for the recommendation rejection.
     */
    rejection_reason: string;

    /**
     * Boolean to determine whether the recommendation is pre-identified or not.
     */
    is_preidentified: boolean;

}
